import React, { useState } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import EndlessScrollChimneyProfileTracksContainer from "./Containers/EndlessScrollChimneyProfileTracksContainer";
import ChimneyProfileContainer from "./Containers/ChimneyProfileContainer";
import BackToTop from "../../Components/Elements/BackToTop";
import "./ChimneyProfile.less";

const ChimneyProfileTracksPage = ({ match }) => {
  const [trackCount, setTrackCount] = useState(0);

  return (
    <ChimneyProfileContainer
      chimDir={match.params.chimDir}
      render={({ profile, loading: profileLoading }) => {
        if (profileLoading) {
          return null;
        }
        return (
          <div>
            <Row>
              <Col xs={12}>
                <h2 className="page-header">
                  <Link to={`/profile/${match.params.chimDir}`}>{profile.full_name} Chimney</Link>: Previous Tracks
                </h2>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <EndlessScrollChimneyProfileTracksContainer
                  chimDir={match.params.chimDir}
                  loading={profileLoading}
                  onItemsChange={setTrackCount}
                />
              </Col>
            </Row>

            <BackToTop show={trackCount >= 30} />
          </div>
        );
      }}
    />
  );
};

export default ChimneyProfileTracksPage;
